export default __webpack_public_path__ + "static/media/search.5e0edb23.svg";